export const Pages : { [key: string] : any }  = {
    bg : {
        registration: {
            title: "Регистрация",
            first_name: 'Име',
            last_name: 'Фамилия',
            email: 'Имейл',
            password: 'Парола',
            password_confirmation: 'Повтори паролата',
            reg: "Вече имам регистрация.",
            login: "Вход",
            button: 'Регистрирай се'
        },
        login: {
            title: "Вход",
            username: 'Потребителско име',
            password: 'Парола',
            email: 'Имейл',
            forgottenPassword: "Забравена парола?",
            noReg: "Все още нямам регистрация.",
            registration: "Регистрирай се",
            button: 'Вход'
        },
        forgottenpassword: {
            title: "Забравена парола",
            email: 'Имейл',
            button: 'Изпрати имейл'
        },
        emailSent: {
            title: "Имейл за въстановяване беше изпратен!",
            info: "Имейл с нова парола за вход в приложението беше изпратен на имейла Ви",
            button: "Затвори"
        },
        accountinfo: {
            name: "Име",
            lastName: "Фамилия",
            email: "Имейл",
            telephone: "Телефон",
            button: "Запази",
            delete: "Изтрий акаунта"

        },
        settings: {
            title: "Настройки",
            share: "Автоматично споделяне",
            shareinfo: "Сподели активността ми с други потребители",
            changepassword: "Промени парола"
        },
        changepassword: {
            newPassword: 'Нова парола',
            confirmPassword: 'Потвърди новата парола',
            button: 'Запази',
            forgottenPassword: 'Забравена парола'
        },
        resetpassword: {
            title: "Промени Парола",
            currentPassword: 'Текуща парола',
            newPassword: 'Нова парола',
            confirmPassword: 'Повтори паролата',
            forgottenPassword: "Забравена парола",
            button: 'Промени парола'
        },
        home: {
            search: "Какво търсиш?",
            sg1: "Продукти",
            sg2: "Услуги"
        },
        noConnectivity: {
            label: "Липсва интернет връзка",
            btn: "Опитай отново"
        },
        account: {
            gotoprofile: "Влез в профила си",
            login: "Вход",
            account: "Профил",
            settings: "Настройки",
            invite: "Покани и спечели",
            vouchers: "Ваучери",
            contacts: "Контакти",
            legal: "Правни документи",
            rate: "Оцени ни",
            facebook: "Харесай ни във Facebook",
            instagram: "Последвай ни в Instagram",
            logout: "Излез",
            logoutLabel: "Сигурен ли си, че искаш да излезеш от акаунта си?",
            logoutConfirm: "Излез",
            logoutCancel: "Върни се"
        },
        documents: {
            title: "Правни документи",
            GTC: "Общи условия",
            DPP: "Политика за личните данни",

        },
        contacts: {
            title: "Контакти",
            QO: "Въпроси свързани с мои поръчки",
            QOinfo: "Относно въпроси свързани с поръчки, погледнете имейла и телефона в профила на търговеца и се свържете с него.",
            QAinfo: "При технически проблеми и въпроси свързани с приложението се свържете с нас на:",
            QA: "Въпроси свързани с приложението"
        },
        modals: {
            notLoggedIn: {
                text: "Влез в профила си за да продължиш",
                registration: "Регистрация",
                logIn: "Влез"
            },
            datetime: {
                change: 'Промени',
                save: "Запази"
            }
        },
        product: {
            stock: 'Налични: ',
            delivery: 'Доставка: ',
            pricing: 'Ценоразпис',
            descrpition: 'Описание',
            partner: 'Търговец',
            goToPartner: 'Виж',
            size: 'Избери размер',
            color: 'Избери цвят',
            pickUp: 'Вземане от магазин',
            freeDeliveryOver: 'Безплатна доставка над',
            carrier: 'Изпращане до офис на куриер',
            addres: 'Изпращане до адрес',
            privateTransport: 'Личен транспорт на търговеца',
            specifications: 'Характеристики',
            warranty: 'Гаранция',
            return: 'Политика за връщане',
            returnText: '30 дни след датата на доставка. Продуктът не трябва да е използван.',
            reviews: 'Ревюта',
            seeAll: 'Виж всички',
            buywith: 'Купи с',
            similarProducts: 'Подобни продукти',
            group: 'Създай група',
            save: '(Спести до 25%)',
            addToCart: 'Добави в количката'
        },
        service: {
            stock: 'Налични: ',
            delivery: 'Доставка: ',
            pricing: 'Ценоразпис',
            descrpition: 'Описание',
            partner: 'Търговец',
            goToPartner: 'Виж',
            size: 'Избери размер',
            color: 'Избери цвят',
            pickUp: 'Вземане от магазин',
            freeDeliveryOver: 'Безплатна доставка над',
            carrier: 'Изпращане до офис на куриер',
            addres: 'Изпращане до адрес',
            privateTransport: 'Личен транспорт на търговеца',
            specifications: 'Характеристики',
            warranty: 'Гаранция',
            return: 'Политика за връщане',
            returnText: '30 дни след датата на доставка. Продуктът не трябва да е използван.',
            reviews: 'Ревюта',
            seeAll: 'Виж всички',
            buywith: 'Купи с',
            similarProducts: 'Подобни продукти',
            group: 'Създай група',
            save: '(Спести до 25%)',
            addToCart: 'Добави в количката',
            location: 'Избери локация',
            dateTime: "Избери дата и час",
            freeReturn: "Безплатно отказване",
            freeReturnText: "Безплатно отказване до 14 дни след датата на поръчка. Ако поръчката бъде отказана след безплатния срок за Отказване, спрямо политиката на Търговеца, ще бъдат удържани 35% от стойността на поръчката.",
            information: 'Информация',
            category: 'Категория',
            type: 'Тип',
            includes: 'Включва'
        },
        categories: {
            title: "Категории",
            sg1: "Продукти",
            sg2: "Услуги"
        },
        subcatresults: {

        },
        partner: {
            sg1: "Продукти",
            sg2: "Услуги"
        },
        partnerinfo: {
            workingTime: 'Работно време',
            sellerInfo: 'Информация',
            businessDescription: 'Бизнес',
            description: 'Описание',
            phone: 'Телефон:',
            address: 'Адрес:',
            warranty: 'Гаранция',
            return: 'Политика за връщане',
            privacy: 'Политика за лични данни'
        },
        favoutites: {
            title: 'Любими',
            sg1: "Продукти",
            sg2: "Услуги"
        },
        inviteContacts: {
            title: "Покани приятели",
            subtitle: "*Изберете контактите, които искате да поканите. За всеки трима от тях, които се регистрират, ще получите ваучер на стойност 5 лв.",
            pickedContacts: "Ибрани контакти",
            invitesBtn: "Изпрати {num} покани",
            contacts: "Контакти",
            nameDef: "Без име",
            emailDef: "Без имейл",
            phoneDef: "Без телефон",
            contactPermission: "Трябват ни контакти, за да можем да изпращаме покани на вашите приятели"
        },
        sentInvites: {
            title: "Поканите ви бяха изпратени успешно!",
            info: "Веднъж щом трима от поканените се регистрират, ще получите ваучер на стойност 5 лв.",
            button: "Затвори"
        },
        order_home: {
            title: "Данни за поръчката",
            del: 'Доставка',
            home: 'Доставка до адрес',
            office: 'До офис на Speedy',
            invoice: 'Адрес за фактуриране',
            pay: 'Плащане',
            card: 'Плащане с карта',
            add: 'Дбави адрес',
            addCard: 'Добави карта',
            cod: 'Наложен платеж',
            paymentChoice: "Метод на плащане",
            deliveryChoice: "Метод на доставка",

        },
        shared: {
            fullStock: ' брой',
            fullStocks: ' броя',
            inStock: "В наличност",
            notInStock: "Не е в наличност",
            last: "Последна",
            freeN: "Безплатно",
            freeW: "Безплатна",
            freeDel: "Безплатна доставка над ",
            stock: ' бр.',
            day: ' ден',
            days: ' дни',
            currency: ' лв.',
            valuePerStock: ' лв./бр.',
            valuePerStockFor: ' лв./бр. за ',
            stocks: ' броя',
            months: ' месец/а',
            locationSelection: "Моля, първо изберете локация",
            monday: "Понеделник",
            tuesday: "Вторник",
            wednesday: "Сряда",
            thursday: "Четвъртък",
            friday: "Петък",
            saturday: "Събота",
            sunday: "Неделя",
            total: "Общо",
            sumInfo: "*Цената за доставка ще се изчисли на следващата стъпка",
            continue: "Продължи",
            block: "Блок",
            entrance: "Вход",
            floor: "Етаж",
            apartment: "Апартамент",
            noWarranty: "Продуктът няма гаранция."
        },
        cart: {
            title: "Количка"
        },
        address_select: {
            title: "Моите адреси"
        },
        order_invoice_select: {
            title: "Данни за фактура"
        },
        address_modified: {
            title: "Добави адрес"
        },
        order_invoice_edit: {
            title: "Добави адрес за фактура"
        },
        order: {
            title: "Моята поръчка",
            tmpSum: "Междинна сума:",
            delSum: "Доставка:",
            totalSum: "Общо:",
            payBtn: "Плати"
        },
        categoryproducts: {
            search: 'Какво търсиш?'
        }
    }
}